<template>
  <g :id="hand.id">
    <path fill="#231F20" d="M73.8831,109.9996c-0.0003,1.0396-0.8433,1.8821-1.8829,1.8818
      c-1.0396-0.0003-1.8822-0.8433-1.8818-1.8829c0.0003-1.0388,0.8421-1.881,1.8808-1.8819
      C73.039,108.1174,73.8819,108.9598,73.8831,109.9996z"/>
    <line fill="none" x1="72.1148" y1="111.8827" x2="71.8871" y2="111.8827"/>
    <polygon fill="#231F20" points="71.7168,111.8826 72.2839,111.8819 72.8508,124.172 71.15,124.1719 			"/>
    <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="72" y1="111.8827" x2="72.0003" y2="67.48"/>
  </g>
</template>

<script>
export default {
  name: 'sdHandSecond',
  props: ['data'],
  computed: {
    hand() {
      if (this.data.hand) return this.data.hand;
    },
    watch() {
      if (this.data.watch) return this.data.watch;
    },
  },
};
</script>
